import React, { useEffect, useState } from "react";
import { sanityClient, urlFor } from "../lib/sanityClient";
import { motion } from "framer-motion";
import { fadeUp, stagger, viewport, spring } from "../lib/motion";
import "../styles/Footer.css";

const QUERY = `*[_type == "footerSection"][0]{
  footerLinks, copyrightText, poweredByText, poweredByLogo,
  followUsText, socialLinks
}`;

const Footer = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    sanityClient.fetch(QUERY).then(setData);
  }, []);

  if (!data) return null;

  return (
    <motion.div
      className="footer-wrapper"
      initial="hidden"
      whileInView="visible"
      viewport={viewport}
      variants={stagger(0.15)}
    >
      {/* New top section */}
      <motion.div className="footer-top-section" variants={fadeUp}>
        <div className="footer-links">
          {(data.footerLinks || []).map((link) => (
            <a
              key={link._key}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.label}
            </a>
          ))}
        </div>
      </motion.div>

      {/* Existing footer */}
      <motion.footer className="custom-footer" variants={fadeUp}>
        <div className="footer-right">
          {data.poweredByText}{" "}
          <img
            src={urlFor(data.poweredByLogo).url()}
            alt="CoRover.ai"
            className="corover-logo"
          />
        </div>

        <div className="footer-center">{data.copyrightText}</div>

        <div className="footer-left">
          <span>{data.followUsText}</span>
          {(data.socialLinks || []).map((social) => (
            <motion.a
              key={social._key}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.label}
              whileHover={{ y: -3, scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
              transition={spring}
            >
              <img
                src={urlFor(social.icon).url()}
                alt={social.label}
                className="social-icon"
              />
            </motion.a>
          ))}
        </div>
      </motion.footer>
    </motion.div>
  );
};

export default Footer;
